module.exports = __webpack_public_path__ + "img/2024nh3.64970832.jpg";